module.exports = __webpack_public_path__ + "static/fiftyoneten-37014973a78f76ecead840890508eaf4.png";